module.exports = __webpack_public_path__ + "static/media/Detachable Viewports.38f425d0.png";